<template>
  <span class="badgeSeason" v-if="showSeason">season</span>
</template>

<script>
export default {
  props: {
    showSeason: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.badgeSeason {
  background-color: rgb(218, 235, 254);
  padding: 6px;
  border-radius: 6px;
  margin-left: 10px;
  font-size: 12px;
}
</style>
